import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');

$(function () {
    if (inBackend) return;

    $('.list-filter').each(function () {
        const $element = $(this);

        const $any = $element.find('input.list-filter-checkbox[data-id="_any"]');
        const $checkboxes = $element.find('input.list-filter-checkbox').not('[data-id="_any"]');

        const $items = $element.find('.list-filter-item');
        const $itemList = $element.find('.dynamic-list-list');

        const parseCategories = ($item) => {
            const raw = $item.attr('data-categories') || '[]';
            try {
                return JSON.parse(raw);
            } catch (e) {
                return [];
            }
        };

        const getSelectedIds = () => {
            return $checkboxes
                .filter(':checked')
                .map(function () { return $(this).data('id'); })
                .get();
        };

        const applyFilter = () => {
            const selected = getSelectedIds();

            $itemList.fadeOut(250, function () {
                $items.each(function () {
                    const $item = $(this);

                    if (selected.length === 0) {
                        $item.show();
                        return;
                    }

                    const categories = parseCategories($item);
                    const show = selected.some((id) => categories.includes(id));

                    if (show) {
                        $item.show();
                    } else {
                        $item.hide();
                    }
                });

                $itemList.fadeIn(250);
            });
        };

        const syncAnyCheckbox = () => {
            const selected = getSelectedIds();
            if ($any.length) {
                $any.prop('checked', selected.length === 0);
            }
        };

        if ($any.length) {
            $any.on('change', function () {
                if ($(this).is(':checked')) {
                    $checkboxes.prop('checked', false);
                }
                applyFilter();
            });
        }

        $checkboxes.on('change', function () {
            if ($(this).is(':checked') && $any.length) {
                $any.prop('checked', false);
            }
            syncAnyCheckbox();
            applyFilter();
        });

        syncAnyCheckbox();
        applyFilter();
    });
});
